<template>
  <div id="fiscalIbsCbs" class="vs-con-loading__container w-full">
    <vs-row class="mb-4" vs-type="flex" vs-w="12">
      <vs-col vs-w="12">
        <h4 style="color: #b4aa99">CST Padrão (IBS/CBS)</h4>
        <span class="text-sm" style="color: #b4aa99">
          Aplicado quando não houver exceção cadastrada para o município do tomador.
        </span>
      </vs-col>
    </vs-row>

    <vs-row class="mb-6" vs-type="flex" vs-w="12">
      <vs-col vs-w="6" class="pr-2">
        <vs-input
          v-model="regra.padrao_cst"
          v-validate="'required'"
          class="inputx w-full"
          label="CST Padrão IBS/CBS"
          name="padrao_cst"
          placeholder="Ex.: 01"
        />
        <span v-show="errors.has('padrao_cst')" class="text-danger text-sm">{{
          $validators.empty
        }}</span>
      </vs-col>
    </vs-row>

    <vs-table
      :data="excecoesLista"
      max-items="10"
      maxHeight="50vh"
      noDataText="Nenhuma exceção cadastrada"
      pagination
      search
    >
      <template slot="header">
        <vs-row vs-align="center" vs-type="flex" vs-w="12">
          <vs-col vs-w="8">
            <h4 style="color: #b4aa99">Exceções por Município</h4>
          </vs-col>
          <vs-col vs-align="center" vs-justify="flex-end" vs-type="flex" vs-w="4">
            <ModalExcecaoFiscal modo="cadastro" @salvar="adicionarExcecao" />
          </vs-col>
        </vs-row>
      </template>

      <template slot="thead">
        <vs-th sort-key="cMun">Código Município (IBGE)</vs-th>
        <vs-th sort-key="nome">Município</vs-th>
        <vs-th sort-key="cst">CST (IBS/CBS)</vs-th>
        <vs-th>Ações</vs-th>
      </template>

      <template slot-scope="{ data }">
        <vs-tr v-for="(tr, indextr) in data" :key="indextr">
          <vs-td :data="data[indextr].cMun">{{ data[indextr].cMun }}</vs-td>
          <vs-td :data="data[indextr].nome">{{ data[indextr].nome || "-" }}</vs-td>
          <vs-td :data="data[indextr].cst">{{ data[indextr].cst }}</vs-td>
          <vs-td>
            <ModalExcecaoFiscal
              :excecao="data[indextr]"
              modo="edicao"
              @excluir="removerExcecao"
              @salvar="atualizarExcecao"
            />
          </vs-td>
        </vs-tr>
      </template>
    </vs-table>

    <vs-row class="mt-6" vs-justify="flex-end" vs-type="flex" vs-w="12">
      <vs-button color="success" size="small" type="relief" @click="salvar"
      >Salvar Parametrização
      </vs-button>
    </vs-row>
  </div>
</template>

<script>
import components from "@/components/default/exports.js";
import FiscalRegraIbsCbsService from "@/services/FiscalRegraIbsCbsService.js";
import ModalExcecaoFiscal from "./modal.vue";

export default {
  name: "ListaFiscalIbsCbs",
  data () {
    return {
      id: null,
      regra: {
        padrao_cst: "",
        excecoes: {}
      }
    };
  },
  computed: {
    excecoesLista () {
      return Object.keys(this.regra.excecoes).map(cMun => ({
        cMun,
        nome: this.regra.excecoes[cMun].nome,
        cst: this.regra.excecoes[cMun].cst
      }));
    }
  },
  methods: {
    async carregar () {
      await this.$vs.loading({ container: "#fiscalIbsCbs", scale: 0.6 });
      try {
        const res = await FiscalRegraIbsCbsService.buscar();
        this.id = res.id;
        this.regra = res.regra;
      } catch (err) {
        await this.tratarErro(err);
      } finally {
        await this.$vs.loading.close("#fiscalIbsCbs > .con-vs-loading");
      }
    },
    adicionarExcecao (excecao) {
      this.regra.excecoes = {
        ...this.regra.excecoes,
        [excecao.cMun]: { nome: excecao.nome, cst: excecao.cst }
      };
    },
    atualizarExcecao (excecao) {
      this.adicionarExcecao(excecao);
    },
    removerExcecao (cMun) {
      const excecoes = { ...this.regra.excecoes };
      delete excecoes[cMun];
      this.regra.excecoes = excecoes;
    },
    async salvar () {
      const valido = await this.$validator.validateAll();
      if (!valido) {
        this.$vs.notify(this.$notify.Empty);
        return;
      }
      await this.$vs.loading({ container: "#fiscalIbsCbs", scale: 0.6 });
      try {
        const res = await FiscalRegraIbsCbsService.salvar(this.id, this.regra);
        if (res && res.id) {
          this.id = res.id;
        }
        this.$vs.notify({
          title: "Sucesso",
          text: "Parametrização fiscal salva com sucesso!",
          color: "success"
        });
      } catch (err) {
        await this.tratarErro(err);
      } finally {
        await this.$vs.loading.close("#fiscalIbsCbs > .con-vs-loading");
      }
    },
    async tratarErro (err) {
      const error = this.$httpErrors(err);
      this.$vs.notify(error);
      if (error.code == 401) {
        await window.localStorage.clear();
        await this.$router.push("/");
      }
    }
  },
  components: {
    ...components,
    ModalExcecaoFiscal
  },
  async mounted () {
    await this.carregar();
  }
};
</script>
